// import axios from 'util/axios'
import HttpService from 'services/core/HttpService'

export function fetchAssignmentData(
  assessmentId: number | string,
  classroomId?: number | string
) {
  return HttpService.get(
    `/student/classrooms/${classroomId}/assignments/${assessmentId}?tts=true`
  )
}

export function submitAssignmentAnswers(
  assignmentId: number | string,
  classroomId: number | string,
  answers: Array<{ question_id: number; selected_choice: number }>
) {
  return HttpService.post(
    `/student/classrooms/${classroomId}/assignments/${assignmentId}/submit`,
    { answers }
  )
}

export function submitAssignmentPartialAnswers(
  assignmentId: number | string,
  classroomId: number | string,
  body: any
) {
  return HttpService.put(
    `/student/classrooms/${classroomId}/assignments/${assignmentId}/response`,
    body
  )
}

export function upsertAssignmentAnnotations(
  classroomId: number | string,
  assignmentId: number | string,
  payload: {
    page_id: number
    is_bookmarked: boolean
    student_notes?: string
    student_pen_markings?: any
    student_pen_note_markings?: any
  }
) {
  return HttpService.put(
    `/student/classrooms/${classroomId}/assignments/${assignmentId}/annotations`,
    payload
  )
}
